import React from 'react';
import { WithIcon } from './WithIcon';

export const IconFacebook = WithIcon(
  'Facebook',
  '0 0 754 754',
  <path
    transform="scale(1, -1) translate(-135, -825)"
    d="M568 581v77.8c0 29.6 19.6 36.4 33.2 36.4 13.8 0 84.2 0 84.2 0v128.8l-116.2 0.8c-128.6 0-157.6-96.2-157.6-158.2v-86h-74.6v-132.6h74.6c0-170.8 0-376.6 0-376.6h156.2c0 0 0 207.8 0 376.6h105.4l13.8 133h-119z"
  />
);
